import { render, staticRenderFns } from "./boat-review.vue?vue&type=template&id=0e83345a"
import script from "./boat-review.vue?vue&type=script&lang=js"
export * from "./boat-review.vue?vue&type=script&lang=js"
import style0 from "./boat-review.vue?vue&type=style&index=0&id=0e83345a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports